/* ── Pack Builder — Single Page, 3 Phases ─────────────── */
(function () {
  'use strict';

  const app = document.getElementById('pb-app');
  if (!app) return;

  const SOCK_HANDLE  = app.dataset.sockCollection || 'best72';
  const GIFT_HANDLE  = app.dataset.giftCollection  || 'free-gift';
  const CONTINUE_URL = app.dataset.continueUrl     || '/collections/best72';
  const MAX = 4;

  let sockProducts   = [];
  let giftProducts   = [];
  let selectedSocks  = [];   // [{variantId, title, image, price}]
  let selectedGift   = null; // {variantId, title, image}
  let allCartedSocks = [];   // accumulates across upsell rounds

  // ── DOM refs ───────────────────────────────────────────
  const phase1        = document.getElementById('pb-phase-1');
  const phase2        = document.getElementById('pb-phase-2');
  const phase3        = document.getElementById('pb-phase-3');
  const sockGrid      = document.getElementById('pb-sock-grid');
  const giftGrid      = document.getElementById('pb-gift-grid');
  const slots         = document.querySelectorAll('.pb-slot');
  const stickySlots   = document.querySelectorAll('.pb-sticky__slot');
  const progressLabel = document.getElementById('pb-progress-label');
  const stickyLabel   = document.getElementById('pb-sticky-label');
  const stickyBtn     = document.getElementById('pb-sticky-btn');
  const congratsEl    = document.getElementById('pb-congrats');
  const summaryEl     = document.getElementById('pb-summary');

  // ── Init ──────────────────────────────────────────────
  async function init() {
    showLoading(sockGrid);
    showLoading(giftGrid);
    showPhase(1);

    try {
      [sockProducts, giftProducts] = await Promise.all([
        loadProducts(SOCK_HANDLE),
        loadProducts(GIFT_HANDLE)
      ]);
      renderGrid(sockGrid, sockProducts, 'sock');
      renderGrid(giftGrid, giftProducts, 'gift');
    } catch (e) {
      sockGrid.innerHTML = '<p style="padding:40px;text-align:center;color:#999">Could not load products. Please refresh.</p>';
    }
    updateProgress();
  }

  // ── Load products ──────────────────────────────────────
  async function loadProducts(handle) {
    const res  = await fetch(`/collections/${handle}/products.json?limit=250`);
    const data = await res.json();
    return data.products || [];
  }

  // ── Render product grid ────────────────────────────────
  function renderGrid(container, products, type) {
    if (!products.length) {
      container.innerHTML = '<p style="padding:40px;text-align:center;color:#999">No products found.</p>';
      return;
    }
    container.innerHTML = products.map(p => {
      const variant    = p.variants.find(v => v.available) || p.variants[0];
      const img        = (p.images[0] || {}).src || '';
      const imgResized = img ? img.replace(/(\.\w+)(\?.*)?$/, '_600x600$1') : '';
      const price      = formatMoney(variant.price);
      const isGift     = type === 'gift';
      return `
        <div class="pb-card"
          data-type="${type}"
          data-variant-id="${variant.id}"
          data-title="${escHtml(p.title)}"
          data-image="${escHtml(imgResized)}"
          data-price="${escHtml(price)}">
          <div class="pb-card__img">
            ${img ? `<img src="${imgResized}" alt="${escHtml(p.title)}" loading="lazy" width="400" height="400">` : ''}
          </div>
          ${isGift ? '<span class="pb-card__free">FREE</span>' : ''}
          <div class="pb-card__check">✓</div>
          <div class="pb-card__info">
            <div class="pb-card__name">${escHtml(p.title)}</div>
            ${!isGift ? `<div class="pb-card__price">${price}</div>` : ''}
          </div>
        </div>`;
    }).join('');
    container.addEventListener('click', onCardClick);
  }

  // ── Card click ─────────────────────────────────────────
  function onCardClick(e) {
    const card = e.target.closest('.pb-card');
    if (!card) return;

    const type = card.dataset.type;

    // ── Sock selection ────────────────────────────────
    if (type === 'sock') {
      if (card.classList.contains('maxed')) return;
      const vid = card.dataset.variantId;
      const idx = selectedSocks.findIndex(s => s.variantId === vid);
      if (idx > -1) {
        selectedSocks.splice(idx, 1);
        card.classList.remove('selected');
      } else {
        if (selectedSocks.length >= MAX) return;
        selectedSocks.push({
          variantId: vid,
          title:     card.dataset.title,
          image:     card.dataset.image,
          price:     card.dataset.price
        });
        card.classList.add('selected');
      }
      updateProgress();
    }

    // ── Gift selection — auto-proceed immediately ─────
    if (type === 'gift') {
      if (card.classList.contains('loading')) return; // prevent double-click
      selectedGift = {
        variantId: card.dataset.variantId,
        title:     card.dataset.title,
        image:     card.dataset.image
      };
      // Visual: highlight chosen card, dim others
      document.querySelectorAll('.pb-card[data-type="gift"]').forEach(c => c.classList.remove('selected'));
      card.classList.add('selected', 'loading');
      // Auto-proceed
      confirmGift(card);
    }
  }

  // ── Phase 1 progress ───────────────────────────────────
  function updateProgress() {
    const count = selectedSocks.length;

    slots.forEach((slot, i) => {
      const filled = i < count;
      slot.classList.toggle('filled', filled);
      const thumb = slot.querySelector('.pb-slot-thumb');
      if (thumb) thumb.src = filled && selectedSocks[i] ? selectedSocks[i].image : '';
    });

    stickySlots.forEach((slot, i) => {
      const filled = i < count;
      slot.classList.toggle('filled', filled);
      const img = slot.querySelector('img');
      if (img) img.src = filled && selectedSocks[i] ? selectedSocks[i].image : '';
    });

    if (progressLabel) {
      if (count === 0) {
        progressLabel.innerHTML = 'Pick <strong>4 socks</strong> to unlock your free pair';
      } else if (count < MAX) {
        progressLabel.innerHTML = `<strong>${count}/${MAX}</strong> — pick ${MAX - count} more to unlock your free pair`;
      } else {
        progressLabel.innerHTML = '🎉 <strong>4/4</strong> — Choose your next step below';
      }
    }

    document.querySelectorAll('.pb-card[data-type="sock"]').forEach(c => {
      c.classList.toggle('maxed', count >= MAX && !c.classList.contains('selected'));
    });

    if (count >= MAX) {
      showCongrats();
    } else {
      hideCongrats();
    }

    if (stickyLabel) {
      stickyLabel.innerHTML = count < MAX
        ? `<strong>${count}/4</strong> selected — ${MAX - count} more to go`
        : '🎉 <strong>4/4</strong> — scroll up to choose!';
    }
    if (stickyBtn) {
      stickyBtn.textContent = count >= MAX ? 'Claim Free Pair →' : 'Unlock Free Pair →';
      stickyBtn.classList.toggle('ready', count === MAX);
    }
  }

  // ── Congrats panel ─────────────────────────────────────
  function showCongrats() {
    if (!congratsEl) return;
    congratsEl.classList.add('visible');
    setTimeout(function () {
      congratsEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }, 60);
  }
  function hideCongrats() {
    if (congratsEl) congratsEl.classList.remove('visible');
  }

  // ── Phase transitions ──────────────────────────────────
  function showPhase(n) {
    [phase1, phase2, phase3].forEach((p, i) => {
      if (p) p.classList.toggle('active', i + 1 === n);
    });
    app.className = app.className.replace(/phase-\d/g, '').trim();
    app.classList.add(`phase-${n}`);
    window.scrollTo({ top: app.getBoundingClientRect().top + window.scrollY - 80, behavior: 'smooth' });
  }

  // ── "Add Another 4" — upsell round ────────────────────
  async function addMoreSocks() {
    if (selectedSocks.length < MAX) return;
    const btn = document.getElementById('pb-add-more');
    setLoading(btn, true);
    try {
      await addToCart(selectedSocks.map(s => ({
        id: parseInt(s.variantId),
        quantity: 1,
        properties: { _pack_builder: 'true' }
      })));
      allCartedSocks = allCartedSocks.concat(selectedSocks);
      selectedSocks  = [];
      document.querySelectorAll('.pb-card[data-type="sock"]').forEach(c => {
        c.classList.remove('selected', 'maxed');
      });
      hideCongrats();
      updateProgress();
      window.scrollTo({ top: app.getBoundingClientRect().top + window.scrollY - 80, behavior: 'smooth' });
    } catch (e) {
      alert('Cart error: ' + e.message);
    }
    setLoading(btn, false);
  }

  // ── "Claim Free Pair" — go to Phase 2 ─────────────────
  async function gotoGift() {
    if (selectedSocks.length < MAX) return;
    const btn = document.getElementById('pb-goto-gift');
    setLoading(btn, true);
    try {
      await addToCart(selectedSocks.map(s => ({
        id: parseInt(s.variantId),
        quantity: 1,
        properties: { _pack_builder: 'true' }
      })));
      allCartedSocks = allCartedSocks.concat(selectedSocks);
      hideCongrats();
      setLoading(btn, false); // always reset so button works on next round
      showPhase(2);
      selectedGift = null;
    } catch (e) {
      alert('Cart error: ' + e.message);
      setLoading(btn, false);
    }
  }

  // ── Phase 2 → 3: gift chosen, auto-proceed ─────────────
  async function confirmGift(card) {
    if (!selectedGift) return;
    try {
      await addToCart([{
        id: parseInt(selectedGift.variantId),
        quantity: 1,
        properties: { _free_gift: 'true', 'Free gift': '✓' }
      }]);
      if (card) card.classList.remove('loading');
      buildSummary();
      showPhase(3);
    } catch (e) {
      if (card) card.classList.remove('loading', 'selected');
      selectedGift = null;
      alert('Cart error: ' + e.message);
    }
  }

  // ── Success summary ────────────────────────────────────
  function buildSummary() {
    if (!summaryEl) return;
    const allSocks = allCartedSocks.length ? allCartedSocks : selectedSocks;
    const sockRows = allSocks.map(s =>
      `<div class="pb-summary__item">
        <img src="${escHtml(s.image)}" alt="${escHtml(s.title)}">
        <span>${escHtml(s.title)}</span>
        <span>${s.price}</span>
      </div>`
    ).join('');
    const giftRow = selectedGift
      ? `<div class="pb-summary__item">
          <img src="${escHtml(selectedGift.image)}" alt="${escHtml(selectedGift.title)}">
          <span class="pb-summary__gift">${escHtml(selectedGift.title)}</span>
          <span class="pb-summary__free">FREE</span>
        </div>`
      : '';
    summaryEl.innerHTML = sockRows + giftRow;
  }

  // ── Reset ──────────────────────────────────────────────
  function reset() {
    selectedSocks  = [];
    selectedGift   = null;
    allCartedSocks = [];
    document.querySelectorAll('.pb-card').forEach(c => c.classList.remove('selected', 'maxed', 'loading'));
    // Always re-enable action buttons so they work in the next round
    ['pb-add-more', 'pb-goto-gift'].forEach(function(id) {
      setLoading(document.getElementById(id), false);
    });
    hideCongrats();
    updateProgress();
    showPhase(1);
  }

  // ── Cart API ───────────────────────────────────────────
  async function addToCart(items) {
    const ctrl = new AbortController();
    const timer = setTimeout(function () { ctrl.abort(); }, 8000);
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items }),
        signal: ctrl.signal
      });
      if (!res.ok) {
        const err = await res.json().catch(function() { return {}; });
        throw new Error(err.description || err.message || 'HTTP ' + res.status);
      }
      return await res.json();
    } catch (e) {
      if (e.name === 'AbortError') throw new Error('Request timed out. Please try again.');
      throw e;
    } finally {
      clearTimeout(timer);
    }
  }

  // ── Helpers ────────────────────────────────────────────
  function formatMoney(cents) {
    return 'AED ' + (cents / 100).toFixed(0);
  }
  function escHtml(str) {
    return String(str).replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'})[c]);
  }
  function showLoading(el) {
    if (el) el.innerHTML = '<div class="pb-loading"><div class="pb-spinner"></div>Loading products…</div>';
  }
  function setLoading(btn, state) {
    if (!btn) return;
    btn.disabled = state;
    btn.classList.toggle('loading', state);
    if (state) btn.dataset.origText = btn.textContent;
    else btn.textContent = btn.dataset.origText || btn.textContent;
  }

  // ── Button wiring ──────────────────────────────────────
  if (stickyBtn) stickyBtn.addEventListener('click', gotoGift);

  document.addEventListener('click', function (e) {
    if (e.target.id === 'pb-add-more')      addMoreSocks();
    if (e.target.id === 'pb-goto-gift')     gotoGift();
    if (e.target.id === 'pb-claim-another') reset();
    if (e.target.id === 'pb-checkout-btn') {
      e.preventDefault();
      window.location.href = '/checkout';
    }
    if (e.target.id === 'pb-continue-shopping') window.location.href = CONTINUE_URL;
  });

  // ── Sticky bar phase switching ─────────────────────────
  (function () {
    var s1 = document.getElementById('pb-sticky-1');
    var s2 = document.getElementById('pb-sticky-2');
    new MutationObserver(function () {
      var m = app.className.match(/phase-(\d)/);
      var n = m ? parseInt(m[1]) : 1;
      if (s1) s1.style.display = n === 1 ? '' : 'none';
      if (s2) s2.style.display = n === 2 ? '' : 'none';
    }).observe(app, { attributes: true, attributeFilter: ['class'] });
  })();

  init();
})();
